import styled from 'styled-components';
const DropdownIcon = styled.div `
  display: flex;
  align-items: center;
`;
export default DropdownIcon;
